module.exports = __webpack_public_path__ + "img/img_gongzhonghao.a920b8f3.png";